import React, { useState } from 'react';
import useTranslation from '~/app/hooks/useTranslation';
import Icon from '~/app/common/Icon';
import { UserReference, WorkOrderHistory } from '~/workorder/types';
import { formatWorkOrderHistoryDateTime } from './helper';
import classes from './style.module.scss';

export interface HistoryProps {
    history: WorkOrderHistory[];
    createdBy: UserReference;
}

export type HistoryComponent = React.FC<HistoryProps>;

const getEntryAction = (entry: WorkOrderHistory, statusLabel: string, statusChangedPrefix: string, workOrderCreated: string): string => {
    if (entry.status !== undefined && entry.status !== null) {
        return `${statusChangedPrefix} ${statusLabel}`;
    }
    return workOrderCreated;
};

const History: HistoryComponent = ({ history, createdBy }) => {
    const { t } = useTranslation('workorder');
    const [expanded, setExpanded] = useState(false);

    const entries = history ?? [];
    return (
        <div className={classes['card']}>
            <div className={classes['header']} onClick={() => setExpanded(prev => !prev)}>
                <h2 className={classes['header-title']}>
                    <Icon name="schedule" size={20} className={classes['header-icon']} />
                    {t('detail.history')}
                </h2>
                <Icon name={expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'} className={classes['chevron']}/>
            </div>

            {expanded && (
                entries.length > 0 ? (
                    <ul className={classes['timeline']}>
                        {entries.map(entry => {
                            const timestamp = formatWorkOrderHistoryDateTime(entry.createdAt);
                            const statusLabel = t(`statuses.${entry.status}`);
                            const action = getEntryAction(entry, statusLabel, t('detail.statusChangedTo'), t('detail.workOrderCreated'));
                            return (
                                <li key={entry.id} className={classes['entry']}>
                                    <div className={classes['meta']}>
                                        <span className={classes['user']}>{entry.user || t('detail.system')}</span>
                                        {timestamp && (
                                            <>
                                                <span className={classes['separator']}> • </span>
                                                <span className={classes['timestamp']}>{timestamp}</span>
                                            </>
                                        )}
                                    </div>
                                    <p className={classes['action']}>{action}</p>
                                </li>
                            );
                        })}
                        <li key="workOrderCreated" className={classes['entry']}>
                            <div className={classes['meta']}>
                                <span className={classes['user']}>{createdBy.name || t('detail.system')}</span>
                            </div>
                            <p className={classes['action']}>{t('detail.workOrderCreated')}</p>
                        </li>
                    </ul>
                ) : (
                    <p className={classes['empty']}>—</p>
                )
            )}
        </div>
    );
};

export default History;
